export interface ShippingRule {
  id: string;
  minOrderTL: number;   // Free shipping above this amount
  freeShipping: boolean;
  baseCostTL: number;
  name: string;
  label: string;
}

export const DEFAULT_SHIPPING_RULES: ShippingRule[] = [
  {
    id: 'izmir-free',
    name: 'İzmir İçi Ücretsiz',
    label: 'İzmir İçi Kargo',
    minOrderTL: 10000,
    freeShipping: true,
    baseCostTL: 0,
  },
  {
    id: 'izmir-paid',
    name: 'İzmir İçi Ücretli',
    label: 'İzmir İçi Kargo',
    minOrderTL: 0,
    freeShipping: false,
    baseCostTL: 500,
  },
  {
    id: 'national',
    name: 'Yurt İçi Kargo',
    label: 'Yurt İçi',
    minOrderTL: 0,
    freeShipping: false,
    baseCostTL: 2000,
  },
];

export function calculateShippingCost(
  orderTotal: number,
  selectedRuleId: string,
  rules: ShippingRule[] = DEFAULT_SHIPPING_RULES
): number {
  const rule = rules.find((r) => r.id === selectedRuleId);
  if (!rule) return 0;
  if (rule.freeShipping && orderTotal >= rule.minOrderTL) return 0;
  return rule.baseCostTL;
}
